import {ICityVoyagerObj} from '@stencil/hotels-common-reducer/src/types';

export default function transformToVoyagerObject(
  cityName: string,
  cityId: string,
  t = '',
): ICityVoyagerObj {
  return {
    _id: cityId,
    n: cityName,
  };
}
